import { Ticket } from "common/types/ticket.types"
import { get, put } from "hooks/use-http/useHttp"

export const fetchTicketByCode = async (code: string) => {
    const response: Ticket = await get(`ticket/${code}/code`)
    return response
}

export const claimTicket = async (userId: string, eventId: string, ticketCode: string, claimCode: string) => {
    const response: any = await put(`ticket/${userId}/${eventId}/claim`, { ticketCode, claimCode }, {handleError : true})
    return response
}

export const getTicketsByBuyer = async (userId: string) => {
    const response: Ticket[] = await get(`ticket/${userId}/buyer`)
    return response
}

export const getTicketsByOwner = async (userId: string) => {
    const response: Ticket[] = await get(`ticket/${userId}/owner`)
    return response
}

export const shareTicket = async (userId: string, ticketId: string, email: string) =>{
    const response: Ticket = await put(`ticket/${userId}/share/ticket/${ticketId}`, {"emailAddress": email}, {useApiKey: true})
    return response
}

export const useTicketApi = () => {
    return {
        fetchTicketByCode,
        claimTicket,
        getTicketsByBuyer,
        getTicketsByOwner,
        shareTicket
    } as const
}